import axios from 'axios';
import {
	GET_PRICE_GROUPS_SUCCESS,
	GET_PRICE_GROUPS_FAIL,
	CREATE_PRICE_GROUP_SUCCESS,
	UPDATE_PRICE_GROUP_SUCCESS,
	DELETE_PRICE_GROUP_SUCCESS,
	SET_ALERT,
} from './index';

const BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:4000';

const authConfig = () => ({
	headers: { 'x-auth-token': localStorage.getItem('x-auth-token') },
});

export const getAllPriceGroups = () => async (dispatch: any) => {
	try {
		const res = await axios.get(`${BASE_URL}/api/price-groups`, authConfig());
		dispatch({ type: GET_PRICE_GROUPS_SUCCESS, payload: res.data });
	} catch (e) {
		dispatch({ type: GET_PRICE_GROUPS_FAIL });
	}
};

export const createPriceGroup = (name: string, description: string, items: any[]) => async (dispatch: any) => {
	try {
		const res = await axios.post(`${BASE_URL}/api/price-groups`, { name, description, items }, authConfig());
		dispatch({ type: CREATE_PRICE_GROUP_SUCCESS, payload: res.data });
		dispatch({ type: SET_ALERT, payload: { message: 'Price group created.', status: 'success' } });
		return res.data;
	} catch (e) {
		dispatch({ type: SET_ALERT, payload: { message: 'Failed to create price group.', status: 'error' } });
		throw e;
	}
};

export const updatePriceGroup = (id: number, name: string, description: string, items: any[]) => async (dispatch: any) => {
	try {
		const res = await axios.put(`${BASE_URL}/api/price-groups/${id}`, { name, description, items }, authConfig());
		dispatch({ type: UPDATE_PRICE_GROUP_SUCCESS, payload: res.data });
		dispatch({ type: SET_ALERT, payload: { message: 'Price group updated.', status: 'success' } });
		return res.data;
	} catch (e) {
		dispatch({ type: SET_ALERT, payload: { message: 'Failed to update price group.', status: 'error' } });
		throw e;
	}
};

export const deletePriceGroup = (id: number) => async (dispatch: any) => {
	try {
		await axios.delete(`${BASE_URL}/api/price-groups/${id}`, authConfig());
		dispatch({ type: DELETE_PRICE_GROUP_SUCCESS, payload: id });
		dispatch({ type: SET_ALERT, payload: { message: 'Price group deleted.', status: 'success' } });
	} catch (e) {
		dispatch({ type: SET_ALERT, payload: { message: 'Failed to delete price group.', status: 'error' } });
	}
};
